import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';

import { AuthGuard } from '~/auth/guards/auth.guard';
import { OrganizerActivityStatusEnum } from '~/organizer/enums/activity-status.enum';
import { OrganizerSharedPageListComponent } from '~/organizer/shared/components/pages/list/list.component';
import { OrganizerSharedGetOrganizationByQueryIdGuard } from '~/organizer/shared/guards/get-organization-by-query-id/get-organization-by-query-id.guard';
import { OrganizerSharedGetOrganizationFromAuthUserGuard } from '~/organizer/shared/guards/get-organization-from-auth-user/get-organization-from-auth-user.guard';
import { OrganizerSharedHasOrganizationGuard } from '~/organizer/shared/guards/has-organization/has-organization.guard';
import { OrganizerSharedActivityAndTimeslotsResolver } from '~/organizer/shared/resolvers/activity/activity-and-timeslots.resolver';
import { OrganizerSharedActivityResolver } from '~/organizer/shared/resolvers/activity/activity.resolver';

import { OrganizerActivitiesComponent } from './components/pages/activities.component';
import { OrganizerActivityDatesPageComponent } from './components/pages/dates/dates.component';
import { OrganizerActivityPageManageComponent } from './components/pages/manage/manage.component';

const routes: Routes = [
  {
    path: 'organizer.activity.list',
    component: OrganizerActivitiesComponent,
    canActivate: [
      AuthGuard,
      OrganizerSharedGetOrganizationByQueryIdGuard,
      OrganizerSharedGetOrganizationFromAuthUserGuard,
      OrganizerSharedHasOrganizationGuard,
    ],
    data: {
      type: OrganizerActivityStatusEnum.PUBLISHED,
    },
    children: [
      {
        path: 'organizer.activity.published',
        component: OrganizerSharedPageListComponent,
        data: { type: OrganizerActivityStatusEnum.PUBLISHED },
      },
      {
        path: 'organizer.activity.unpublished',
        component: OrganizerSharedPageListComponent,
        data: { type: OrganizerActivityStatusEnum.UNPUBLISHED },
      },
      {
        path: 'organizer.activity.draft',
        component: OrganizerSharedPageListComponent,
        data: { type: OrganizerActivityStatusEnum.DRAFT },
      },
      {
        path: '**',
        redirectTo: 'organizer.activity.published',
      },
    ],
  },
  {
    path: 'organizer.activity.manage/:id',
    component: OrganizerActivityPageManageComponent,
    resolve: {
      activityData: OrganizerSharedActivityResolver,
    },
    canActivate: [
      AuthGuard,
      OrganizerSharedGetOrganizationByQueryIdGuard,
      OrganizerSharedGetOrganizationFromAuthUserGuard,
      OrganizerSharedHasOrganizationGuard,
    ],
  },
  {
    path: 'organizer.activity.manage/:id/organizer.activity.dates',
    component: OrganizerActivityDatesPageComponent,
    resolve: {
      activityAndTimeslotsData: OrganizerSharedActivityAndTimeslotsResolver,
    },
    canActivate: [
      AuthGuard,
      OrganizerSharedGetOrganizationByQueryIdGuard,
      OrganizerSharedGetOrganizationFromAuthUserGuard,
      OrganizerSharedHasOrganizationGuard,
    ],
  },
];

/**
 * Prefix route of the sub modules
 */
@NgModule({
  imports: [
    RouterModule.forChild(routes),
    LocalizeRouterModule.forChild(routes),
  ],
  exports: [RouterModule, LocalizeRouterModule],
})
export class OrganizerActivityRoutingModule {}
